<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" lg="12">
            <CRow>
                <CCol sm="12" lg="12">
                    <div style="margin: 5%">
                        <CContainer>
                            <div class="text-left">
                                <br /><br /><br />
                                <h1 class="custom-40px-600">
                                    Borang Laporan Polis
                                </h1>
                                <p class="custom-16px-400 font-color-98A2B3 text-left mb-4">Maklumat untuk membantu pihak berkuasa menangani aduan anda dengan lebih efisien.</p>
    
                                <h3 class="custom-20px-600">Maklumat Peribadi</h3>
                                <h4 class="custom-16px-400">Nama Penuh:</h4>
                                <input type="text" class="custom-input-grey" disabled v-model="detailReport.FullName"/>
                               <CRow class="mt-3">
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Nombor Telefon:</h4>
                                        <input type="text" class="custom-input-grey" disabled v-model="detailReport.Phone"/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Emel:</h4>
                                        <input type="text" class="custom-input-grey" disabled v-model="detailReport.Email"/>
                                    </CCol>
                                </CRow>
                                
                                <h4 class="custom-20px-600 mt-3">Butiran Aduan</h4>
                                <h4 class="custom-16px-400">Penerangan Aduan:</h4>
                                <CTextarea type="text" rows="9" disabled v-model="detailReport.Description"/>

                                <CRow class="mt-3">
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Tarikh Kejadian:</h4>
                                        <input type="text" class="custom-input-grey" disabled v-model="detailReport.ReportDate"/>
                                    </CCol>
                                     <CCol sm="6">
                                        <h4 class="custom-16px-400">Lokasi Kejadian:</h4>
                                        <input type="text" class="custom-input-grey" disabled v-model="detailReport.Locations"/>
                                    </CCol>
                                </CRow>

                                <h4 class="custom-20px-600 mt-3">Bukti Sokongan</h4>
                                <CTextarea type="text" rows="9" disabled/>

                                <h4 class="custom-20px-600 mt-3">Tandatangan</h4>
                                <CTextarea type="text" rows="9" />

                                <input type="checkbox" /><label class="custom-16px-400 ml-3">Saya mengesahkan bahawa maklumat yang telah saya berikan adalah benar.</label>
                                <div class="text-right">

                                    <CButton class="bg-border-26224E" @click="GoToEdit()">Edit</CButton>
                                    <!-- <CButton class="bg-26224E ml-2 text-white">Hantar Laporan</CButton> -->
                                </div>
                            </div>
                        </CContainer>
                    </div>
                    <br />
    
                </CCol>
    
            </CRow>
        </CCol>
    </div>
</template>


<script>
import Vue from "vue";

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/WhiteHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import { CTextarea } from "@coreui/vue";

export default {
    name: "Login",
    components: {
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            Names: "",
            loading: true,
            detailReport: {}


        };
    },
    created() {
    },
    async mounted() {
        this.GetDetailReport();

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetDetailReport();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GoToVideo() {
            this.$router.push("InterviewerrVideo");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                } else {
                    this.$router.push("HowItWork");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("HowItWork");
                console.error("Error fetching user info:", error);
            }
        },
        GoToEdit()
        {
            this.$router.push("EditBorangLaporan" + "?id=" + this.$route.query.id);
        },
        async GetDetailReport() {
            try {
                const response = await this.$API.get(this.$GetReportDetails + "?id=" + this.$route.query.id, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.detailReport = response.data;
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
    },

};
</script>

<style scoped>
.c-header.c-header-fixed {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1029;
    background: #fff;
    background-size: cover;
}
</style>
